import { toast } from 'material-react-toastify';
import { BasketSummary } from '../../interfaces/Basket/BasketSummary';
import { TableColumn } from '../../components/DataTable/TableColumn';
import { BasketItem } from '../../interfaces/Basket/BasketItem';
import { ImageColumn } from '../../components/DataTable/ImageColumn';
import { TextColumn } from '../../components/DataTable/TextColumn';
import { PriceColumn } from '../../components/DataTable/PriceColumn';
import { DataTable } from '../../components/DataTable/DataTable';
import { updateBasketItemQuantity } from '../../utils/Basket';
import { ButtonColumn } from '../../components/DataTable/ButtonColumn';
import { BasketAmountInput } from './BasketAmountInput';
import { useLocalizedText } from '../../hooks/useLocalizedText';

type BasketTableProps = {
  basket: BasketSummary;
  onUpdate: () => void;
};

export const BasketTable = ({ basket, onUpdate }: BasketTableProps) => {
  const t = useLocalizedText();

  const handleDelete = (row: BasketItem) => {
    updateBasketItemQuantity(row, 0)
      .then(onUpdate)
      .catch((err) => toast.error(err.message));
  };

  const handleChangeQuantity = (row: BasketItem, newQuantity: number) => {
    updateBasketItemQuantity(row, newQuantity)
      .then(onUpdate)
      .catch((err) => toast.error(err.message));
  };

  const columns: TableColumn<BasketItem>[] = [
    {
      id: 'image',
      name: t('common.image'),
      accessor: (row) => <ImageColumn url={row.product.baseImage.path} />,
      align: 'center',
    },
    {
      id: 'name',
      name: t('common.name'),
      accessor: (row) => (
        <TextColumn
          value={row.product.name}
          secondary={row.options[0]?.item.label}
        />
      ),
    },
    {
      id: 'quantity',
      name: t('common.name'),
      accessor: (row) => (
        <BasketAmountInput
          basketItem={row}
          onChange={(x) => handleChangeQuantity(row, x)}
        />
      ),
    },
    {
      id: 'total',
      name: t('common.total'),
      accessor: (row) => (
        <PriceColumn
          value={row.price.amount}
          specialValue={row.total.amount}
          hasOffer={row.hasOfferApplied}
          hasAtCheckoutDiscount={row.hasAtCheckoutDiscount}
        />
      ),
    },
    {
      id: 'delete',
      name: t('common.operation'),
      accessor: (row) => (
        <ButtonColumn
          label={t('common.delete')}
          onClick={() => handleDelete(row)}
        />
      ),
      align: 'center',
    },
  ];

  return (
    <DataTable
      columns={columns}
      totalCount={basket.items.length}
      rows={basket.items}
      hidePagination
      linkGenerator={(item) => `/urun/${item.product.slug}`}
    />
  );
};
